import HubertDialog from 'components/HubertUI/HubertDialog';
import CreateClient from 'components/Clients/CreateClient';
import type { ComponentProps } from 'react';
import { useAppSelector } from 'rtk/query/hooks';
import styles from './styles.module.css';

type Props = ComponentProps<typeof HubertDialog>;

const CreateClientDialog = ({ ...props }: Props) => {
  const dialog = useAppSelector((state) => state.Layout.createClientDialog);

  const customContainer = document.getElementById('main-content') as HTMLElement;
  return (
    <HubertDialog {...props} open={dialog.show} modal={false}>
      <HubertDialog.Content
        position="right"
        portalContent={true}
        portalElement={customContainer}
        className={styles.CreateClientDialogContent}
      >
        <CreateClient key={dialog.show ? 'open' : 'closed'} />
      </HubertDialog.Content>
    </HubertDialog>
  );
};

export default CreateClientDialog;
